import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { UtilitiesService } from '../Services/utilities.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ModuleModel, UserRoleModel } from '../model/AdminArea';
import { } from '../model/AdminArea';
//import { ThrowStmt } from '@angular/compiler';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ProfileImageDialogComponent } from './profile-image-dialog.component';
declare var menumaker;

declare var $: any;
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html'
})
export class LayoutComponent implements OnInit {
  subscription: Subscription;
  message: string = '';
  messageAll: any=[];
  name: string = "";
  email: string = "";
  image: string = "";
  mobile: string = '';
  IsSuperAdmin: boolean = false;
  private dataList: ModuleModel[] = [];
  isShowloader: boolean = false;
  menuList: ModuleModel[] = [];
  childList: ModuleModel[] = [];
  IsAdmin: boolean = true;
  parentModuleList: ModuleModel[] = [];
  //Define Variable for Parent Menu
  IsSuperAdminAccess: boolean = false;
  IsAdminAccess: boolean = false;
  IsCARMAccess: boolean = false;
  IsGeneralInsuranceAccess: boolean = false;
  IsGroupLifeAccess: boolean = false;
  IsLifeAccess: boolean = false;
  IsClaimAccess: boolean = false;
  IsFeeAccess: boolean = false;
  IsSiFAMsAccess: boolean = false;
  IsOfficeAccess: boolean = false;
  IsMisAccess: boolean = false;
  IsArpaAccess: boolean = false;
  selectedMiD: number = 1;
  isDisplayPaymentButton: boolean = true;
  IsDms: boolean = true;
  year = (new Date()).getFullYear();
  twoDigitYear:any;
  constructor(public translate: TranslateService, private router: Router, private service: UtilitiesService, private _sanitizer: DomSanitizer, private dialog: MatDialog, private toastr: ToastrService) {

debugger
    this.twoDigitYear = this.year.toString();


    //this.loadScript();
  }

  ngOnInit(): void {
    //this.loadScript();
    //this.BindParentModule();
    this.BindMessage();
    //this.browserRefresh = browserRefresh;
    this.checkAgentPayment();
    // console.log('refreshed?:', browserRefresh);
    // this.BindModuleByRole();
    if (localStorage.getItem('locale')) {
      const browserLang = localStorage.getItem('locale');
      //translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');  


      this.translate.use(browserLang);
    } else {
      localStorage.setItem('locale', 'en');

      this.translate.use('en');
    }
    var decrpyt = JSON.parse(localStorage.getItem('token'));
    if (decrpyt.partyMaster.contactPerson) {
      var rr = decrpyt.partyMaster.contactPerson;

      let list: [] = rr[0];

      let list2 = list["FirstName"];
      this.name = list["FirstName"] + " " + list["LastName"];
      this.email = list["Email"];
      this.mobile = list["MobileNo"];
      // if (list["Photo"]) {
      //   this.image = "data:image/png;base64," + list["Photo"];
      // }
      // else {
      //   this.image = "../assets/images/avatar.png";
      // }

    }

    this.GetAgentDetails();

    // else {
    //   this.image = "../assets/images/avatar.png";

    // }

  }

  Redirect(url) {
    if (url != '' && url != undefined) {
      // this.router.navigateByUrl(url);

      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate([url]));
    }
    else {
      this.router.navigateByUrl('/dashboard');

    }
  }

  BindModuleByRole() {

    // this.isShowloader=true;
    // var objRoleInput=new UserRoleModel();
    // objRoleInput.CompanyId=this.service.GetCompanyId();
    // objRoleInput.RoleId=this.service.GetLoginUserRoleId();
    // this.service.PostRequestWithheader(this.service.Url+'Admin/ViewUserRoleManagement',objRoleInput).subscribe(resp => {
    //var decypt=this.service.decryptUsingAES256(resp);

    //  var rs=localStorage.getItem("token");
    var data = JSON.parse(localStorage.getItem("token"));
    var rs = data.Role;
    //  if(res.Status)
    //  {
    this.dataList = [];
    // console.log(res.UserRoleManagement.Roles)  ;
    //   this.roleList=res.UserRoleManagement;
    //            this.objModule=res.UserRoleManagement;
    //            if(res.UserRoleManagement[0].Roles!="")
    //            {
    //  var parsedata= JSON.parse( res.UserRoleManagement[0].Roles);
    //  parsedata.forEach(element => {
    //    this.dataList.push(element);
    //            });
    //=====Set roles 


    if (rs.roles != '') {
      this.BindParentModule(JSON.parse(rs.Roles));

      if (localStorage.getItem('localid') == null) {
        this.ToggleHeaderMenu(this.dataList[0].Mid);
      }
      else {
        this.ToggleHeaderMenu(localStorage.getItem('localid'));
      }
    }

    this.isShowloader = false;
    //}

    //  });

  }

  BindParentModule(data) {

    if (data != '') {
      this.dataList = data;
      var allModule = this.dataList.filter((item) => item.SubFormId === '' && item.FormId === '');
      var superadmin = this.dataList.filter((item) => item.SubFormId != '' && item.Mid == "1" && item.Status == true);
      this.IsSuperAdminAccess = superadmin.length > 0 ? true : false;
      var admin = this.dataList.filter((item) => item.SubFormId != '' && item.Mid === "2" && item.Status === true);
      this.IsAdminAccess = admin.length > 0 ? true : false;
      var crm = this.dataList.filter((item) => item.Mid === "3" && item.Status === true);
      this.IsCARMAccess = crm.length > 0 ? true : false;

      var genralinsu = this.dataList.filter((item) => item.Mid === "4" && item.Status === true);
      this.IsGeneralInsuranceAccess = genralinsu.length > 0 ? true : false;
      var isgroupAccess = this.dataList.filter((item) => item.Mid === "5" && item.Status === true);
      this.IsGroupLifeAccess = isgroupAccess.length > 0 ? true : false;
      var life = this.dataList.filter((item) => item.Mid === "6" && item.Status === true);
      this.IsLifeAccess = life.length > 0 ? true : false;
      var claim = this.dataList.filter((item) => item.Mid === "7" && item.Status === true);
      this.IsClaimAccess = claim.length > 0 ? true : false;
      var fee = this.dataList.filter((item) => item.Mid === "8" && item.Status === true);
      this.IsFeeAccess = fee.length > 0 ? true : false;
      var siaform = this.dataList.filter((item) => item.Mid === "9" && item.Status === true);
      this.IsSiFAMsAccess = siaform.length > 0 ? true : false;
      var office = this.dataList.filter((item) => item.Mid === "10" && item.Status === true);
      this.IsOfficeAccess = office.length > 0 ? true : false;
      var mis = this.dataList.filter((item) => item.Mid === "11" && item.Status === true);
      this.IsMisAccess = mis.length > 0 ? true : false;
      var arpa = this.dataList.filter((item) => item.Mid === "12" && item.Status === true);
      this.IsArpaAccess = arpa.length > 0 ? true : false;
    }

    // setTimeout(() => {  
    //   // do something after dom finishes rendering

    //   $("#cssmenu").menumaker({
    //     format: "multitoggle"
    //   });
    // },0);
  }

  checkAgentPayment() {
    debugger
    var reqmodel = { EmpCode: this.service.GetLoginEmployeeCode() };
    this.service.PostRequestWithheader(this.service.Url + "Login/CheckAgentPaymentStatus", reqmodel).subscribe(resp => {
      debugger;
      var res = this.service.ParseResponse(resp);
      if (res.Response.Status) {

        if (res.paymentHistory) {
          if (res.paymentHistory.PaymentStatus === 'Success') {
            this.isDisplayPaymentButton = false;
          }
          if(res.paymentHistory.IsDMS && new Date(res.paymentHistory.SubscriptionEndDate) < new Date(Date.now())){
            this.isDisplayPaymentButton = true;
          }
          this.service.IsDMS = res.paymentHistory.IsDMS;
          this.IsDms = res.paymentHistory.IsDMS;
        }


      }


    });
  }

  BindMessage() {
    debugger;
    this.service.PostRequestWithheader(this.service.Url + "AdminArea/GetActiveMessages", {}).subscribe(resp => {

      var res = this.service.ParseResponse(resp);
      if (res) {

          res.forEach(element => {
            this.messageAll.push({Message:element.Messages})
          });
        //  this.message = res.messageBroadcasts[0].Messages;
      }
    });
  }

  Payment() {
    let agtcode = btoa((encodeURIComponent(this.service.GetLoginEmployeeCode())));
    this.router.navigate(['/payment/' + agtcode]);

  }

  public logOut() {

    localStorage.removeItem("localid");
    localStorage.removeItem("token");
    localStorage.removeItem("moduleid");
    localStorage.removeItem("isLoggedIn");
    this.router.navigate(['/home']);
    this.service.isLoggedIn = false;

  }

  public loadScript() {
    var isFound = false;
    var scripts = document.getElementsByTagName("script")
    for (var i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes("app.min.js")) {
        isFound = true;
      }
    }
    if (!isFound) {
      var dynamicScripts = ['../assets/js/app.min.js', '../assets/js/custom.js'];
      for (var i = 0; i < dynamicScripts.length; i++) {
        let node = document.createElement('script');
        node.src = dynamicScripts[i];
        node.type = 'text/javascript';
        node.async = false;
        node.charset = 'utf-8';
        document.getElementsByTagName('head')[0].appendChild(node);
      }
    }
  }

  ToggleLeftMenu() {

    let body = document.getElementsByTagName('body')[0];

    if (body.className == "left-side-menu-condensed") {
      body.classList.remove("left-side-menu-condensed");   //remove the class
      body.classList.add("sidebar-enable");   //add the class
    }
    else {
      body.classList.add("left-side-menu-condensed");   //remove the class
      body.classList.remove("sidebar-enable");   //add the class
    }

  }

  goToDashboard(mid) {

    localStorage.setItem('localid', mid);
    switch (mid) {
      case ("1"):
        this.router.navigate(['admin/sahome']);
        break;
      case "2":
        this.router.navigate(['adminarea/admhome']);
        break;
      case "9":
        this.router.navigate(['sifams/sifamshomes']);
        break;
      case "3":
        this.router.navigate(['carm/carmhome']);
        break;
      default:
        this.router.navigate(['dashboard']);
        break;
    }




  }

  getChildMenu(menu) {
    this.childList = [];
    // this.childList=JSON.parse(this.service.GetLoginUserModule());
    this.childList = this.dataList;
    return this.dataList.filter((item) => item.Mid === menu.Mid && item.SubFormId == menu.FormId && item.Status === true);
  }

  ToggleHeaderMenu(mid) {

    this.menuList = [];
    // this.dataList=JSON.parse(this.service.GetLoginUserModule());
    //this.dataList=this.dataList
    this.menuList = this.dataList.filter((item) => item.Mid === mid && item.FormId != '' && item.Status === true);

    console.log(this.menuList);
    this.selectedMiD = mid;
    setTimeout(() => {
      $("#cssmenu").menumaker({
        format: "multitoggle"
      });
    }, 0);

  }

  GetAgentDetails(){
    debugger
    let reqModel = {
      CompanyId:this.service.GetCompanyId(),
      PartyCode:this.service.GetLoginEmployeeCode(),
      PartyType:'Agent'
    }
    this.service.PostRequestWithheader(this.service.Url + "AdminArea/GetPartyMaster",reqModel).subscribe(resp => {
      let res = this.service.ParseResponse(resp);
      if(res.Response.Status){
        res.PartyMaster;
        this.image = (res.PartyMaster?.contactPerson[0]?.Photo)?  "data:image/png;base64," + res.PartyMaster?.contactPerson[0]?.Photo : "../../assets/images/avatar.png";
      }
    })
  }

  // Open the "change profile photo" dialog. On upload, save to server + refresh the header image.
  ChangeProfileImage() {
    debugger
    const dialogRef = this.dialog.open(ProfileImageDialogComponent, {
      width: '380px',
      data: { currentImage: this.image }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.image) {
        this.SaveProfileImage(result.image, result.previewImage);
      }
    });
  }

  // Fetch the logged-in agent's PartyMaster, put the new image on contactPerson[0].Photo, and save via UpdatePartyMaster.
  private SaveProfileImage(base64Image: string, previewImage: string) {
    debugger
    this.isShowloader = true;
    let reqModel = {
      CompanyId: this.service.GetCompanyId(),
      PartyCode: this.service.GetLoginEmployeeCode(),
      PartyType: 'Agent'
    };

    this.service.PostRequestWithheader(this.service.Url + "AdminArea/GetPartyMaster", reqModel).subscribe(resp => {
      let res = this.service.ParseResponse(resp);
      if (res.Response && res.Response.Status && res.PartyMaster) {
        let agentDetails = res.PartyMaster;
        if (agentDetails.contactPerson && agentDetails.contactPerson.length > 0) {
          agentDetails.contactPerson[0].Photo = base64Image;

          this.service.PostRequestWithheader(this.service.Url + "AdminArea/UpdatePartyMaster", agentDetails).subscribe(saveResp => {
            let saveRes = this.service.ParseResponse(saveResp);
            if (saveRes.Status) {
              // Update the header image right away.
              this.image = previewImage;
              this.toastr.success(
                this.translate.instant('Profile photo updated successfully'),
                this.translate.instant('Success'));
            } else {
              this.toastr.error(
                this.translate.instant('Unable to update profile photo'),
                this.translate.instant('Error'));
            }
            this.isShowloader = false;
          }, () => { this.isShowloader = false; });
        } else {
          this.isShowloader = false;
          this.toastr.error(
            this.translate.instant('Unable to load your profile'),
            this.translate.instant('Error'));
        }
      } else {
        this.isShowloader = false;
        this.toastr.error(
          this.translate.instant('Unable to load your profile'),
          this.translate.instant('Error'));
      }
    }, () => { this.isShowloader = false; });
  }

}


